import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const RootContainer = styled(Common.RootContainer)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const TitleSection = styled(Common.TitleSection)``;

export const TitleRow = styled(Common.TitleRow)``;

export const Title = styled(Common.Title)``;

export const Popover = styled(Common.Popover)``;

export const PopoverBody = styled(Common.PopoverBody)``;

export const PopoverTitle = styled(Common.PopoverTitle)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const NotFound = styled(Common.NotFound)``;

export const Tabs = styled(Common.Tabs)`
	margin: 0 2rem;
`;

export const Tab = styled(Common.Tab)``;

export const Search = styled(Common.Search)``;

export const TableContainer = styled(Common.TableContainer)``;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)``;

export const TableBody = styled(Common.TableBody)``;

export const TableRow = styled(Common.TableRow)``;

export const TableColumn = styled(Common.TableColumn)`
	padding-top: 1.5rem !important;
	padding-bottom: 0.75rem !important;
`;

export const Buckets = styled(Common.FlexRow)`
	cursor: ${(props) => props.disabled ? "not-allowed" : "pointer"};
	text-transform: uppercase;
`;

export const DSOLogoContainer = styled(Common.FlexColumn)`
	width: 2.5rem;
	height: 2.5rem;
	background-color: ${Theme.creamWhite};
	border-radius: 50%;
	text-align: center;
	margin-top: -0.75rem;
`;

export const DSOLogo = styled.img`
	width: 2.5rem;
	height: 100%;
	max-height: 2.5rem;
`;

export const DSOAbbreviation = styled.span`
	color: ${Theme.green};
	margin: auto 0;
`;

export const TablePagination = styled(Common.TablePagination)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const SquareButton = styled(Common.SquareButton)``;

export const Note = styled(Common.Note)``;